<template>
  <CSectionItem>
    <CItem :title="item.getTitle()">
      <template #left>
        <CFlex>
          <CLinkJobDropdown v-if="!item.deletedOn" :source="item" :targets="otherJobs" :context/>
          <CIcon :name="getJobItemIcon(item.type)"/>
        </CFlex>
      </template>

      <template #body>
        <CJobItemDetails :item/>
      </template>
    </CItem>
  </CSectionItem>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import CFlex from '@/shared/components/CFlex.vue';
  import CIcon from '@/shared/components/CIcon.vue';
  import CItem from '@/shared/components/CItem.vue';
  import CSectionItem from '@/shared/components/section/CSectionItem.vue';
  import Job from '../../models/Job';
  import JobContext from '../../models/JobContext';
  import JobItem from '../../models/JobItem';
  import { getJobItemIcon } from '../../utils/item/icons';
  import CJobItemDetails from './CJobItemDetails.vue';
  import CLinkJobDropdown from './CLinkJobDropdown.vue';

  const props = defineProps<{
    item: JobItem;
    job?: Job;
    context: JobContext;
  }>();

  const otherJobs = computed(() => props.context.jobs.filter(job => job !== props.job));
</script>
